export const questions = [
    {
        title: 'Progressive overload means that you train hard every time:',
        correct: 0
    },
    {
        title: 'Proteins, fats and carbohydrates are also called "micros":',
        correct: 1
    },
    {
        title: 'The amount of calories indicates how good or bad a product is for you:',
        correct: 1
    },
    {
        title: '"ROM" stands for Range Of Motion:',
        correct: 0
    },
    {
        title: 'The more repetitions I do, the more results I will get:',
        correct: 1
    },
    {
        title: 'If I want to lose weight, I mainly use cardio in my workouts:',
        correct: 1
    },
    {
        title: 'I want to be able to complete the entire training, so I divide my powers:',
        correct: 0
    },
    {
        title: 'A negative energy balance means that I have not been sufficiently rested:',
        correct: 1
    },
    {
        title: 'If I want to lose weight I need to cut carbohydrates from my diet',
        correct: 1
    },
    {
        title: 'You only need to take supplements if you train very hard:',
        correct: 1
    }
]

export const results = [
    {
        title: 'You will need some training my friend',
        description: 'You already have some knowledge, but you also have a lot to learn. We will help you with that. Framework and context is incredibly important to achieve long-lasting results. So lets get it on in our Rockstar Bootcamp program!',
        link: 'performance',
        button: {
            label: 'Sign up here',
            link: 'get-in-touch'
        }
    },
    {
        title: 'Great, you are Bootcamp ready!',
        description: 'You already have some knowledge, but you also have a lot to learn. We will help you with that. Framework and context is incredibly important to achieve long-lasting results. So lets get it on in our Rockstar Bootcamp program!',
        link: 'bootcamp'
    }
]